import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BazisSelectComponent } from '@bazis/form/components/base/selects/select.component';
import { BazisInputDateComponent } from '@bazis/form/components/datetime/input-date.component';
import { DateValidators } from '@bazis/form/validators/dateValidators';
import { Modifier, OptionsGeneric } from '@popperjs/core';

@Component({
    selector: 'bazis-select-during-date',
    templateUrl: './select-during-date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisSelectDateComponent extends BazisSelectComponent implements OnInit {
    @ViewChild('dateStartCpm') dateStartCpm: BazisInputDateComponent;

    @ViewChild('dateFinishCpm') dateFinishCpm: BazisInputDateComponent;

    @Input() dateFormat: string = 'YYYY-MM-DD';

    @Input() startDateTitleKey: string = null;

    @Input() endDateTitleKey: string = null;

    @Input() dateFromPlaceholderKey: string = null;

    @Input() dateToPlaceholderKey: string = null;

    @Input() mode: 'picker' | 'input' = 'picker';

    // настройки popper
    @Input() popperOptions: Partial<OptionsGeneric<Partial<Modifier<any, any>>>> = null;

    @Input() forceDateSelection;

    @Input() placeIcon: 'left' | 'right' = 'right';

    dateInterval = new FormGroup(
        {
            dt_start: new FormControl(null),
            dt_finish: new FormControl(null),
        },
        DateValidators.intervalDateTwoControlValidatorFn('dt_start', 'dt_finish', this.dateFormat),
    );

    showDate = false;

    isDateApply = false;

    ngOnInit() {
        this.multiple = false;
    }

    toggleValue(id: string) {
        if (id === 'other') {
            this.showDate = true;
            this.showList = false;
        } else {
            this.dateInterval.reset();
            this.isDateApply = false;
            super.toggleValue(id);
        }
    }

    dateApply() {
        super.toggleValue(this.dateInterval.value);
        this.showDate = false;
        this.isDateApply = true;
    }

    toggleList() {
        super.toggleList();
        this.showDate = false;
    }

    hideDropdown() {
        super.hideList();
        if (
            this.dateStartCpm.isClickOnPopper ||
            this.dateFinishCpm.isClickOnPopper ||
            this.dateStartCpm.hasCleared ||
            this.dateFinishCpm.hasCleared
        )
            return;
        this.showDate = false;
    }
}
